// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3xJKW","checkboxCol":"Table_checkboxCol__3ayk0","emailCol":"Table_emailCol__qzRkJ","actionCol":"Table_actionCol__2aXSQ"};